import React from "react";
import { Modal, Descriptions } from "antd";
import { getModalDims } from "../LedgerResponsive";

export default function TransactionModal({ open, record, onClose, screens, modalDims }) {
  if (!record) return null;

  const dims = modalDims || getModalDims(screens);

  return (
    <Modal
      title="Transaction Details"
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      maskClosable={false}
      keyboard={true}
 width={520}  // <-- Set fixed width
  bodyStyle={{ maxHeight: "70vh", overflowY: "auto", padding: 16 }}
  centered
>      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label="Transaction Date">{record.tran_date}</Descriptions.Item>
        <Descriptions.Item label="Transaction Type">{record.tran_type}</Descriptions.Item>
        <Descriptions.Item label="Units">{record.units}</Descriptions.Item>
        <Descriptions.Item label="Amount">₹{Number(record.amount || 0).toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="NAV">{record.nav}</Descriptions.Item>
        <Descriptions.Item label="Cost Amount">₹{Number(record.cost_amount || 0).toLocaleString()}</Descriptions.Item>
        <Descriptions.Item label="Balance Units">{record.balance_units}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
}
